import campaignApi from "./campaignApi";
import campaignTypes from "./campaignTypes";

const dispatchAsync = (dispatch, types, fn) => async () => {
    dispatch({ type: types.PENDING });
    try {
        const res = await fn();
        const data = res && res.data !== undefined ? res.data : res;
        dispatch({ type: types.SUCCESS, payload: data });
        return data;
    } catch (error) {
        dispatch({ type: types.ERROR, error });
        throw error;
    }
};

export const fetchCampaigns = (branchID, params) => async (dispatch) => {
    return dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.LIST_PENDING, SUCCESS: campaignTypes.LIST_SUCCESS, ERROR: campaignTypes.LIST_ERROR },
        () => campaignApi.list(branchID, params),
    )();
};

export const fetchCampaign = (id) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.DETAIL_PENDING, SUCCESS: campaignTypes.DETAIL_SUCCESS, ERROR: campaignTypes.DETAIL_ERROR },
        () => campaignApi.detail(id),
    )();

export const fetchRecipients = (id, params) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.RECIPIENTS_PENDING, SUCCESS: campaignTypes.RECIPIENTS_SUCCESS, ERROR: campaignTypes.RECIPIENTS_ERROR },
        () => campaignApi.recipients(id, params),
    )();

export const createCampaign = (req) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.CREATE_PENDING, SUCCESS: campaignTypes.CREATE_SUCCESS, ERROR: campaignTypes.CREATE_ERROR },
        () => campaignApi.create(req),
    )();

export const pauseCampaign = (id) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.PAUSE_PENDING, SUCCESS: campaignTypes.PAUSE_SUCCESS, ERROR: campaignTypes.PAUSE_ERROR },
        () => campaignApi.pause(id),
    )();

export const resumeCampaign = (id) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.RESUME_PENDING, SUCCESS: campaignTypes.RESUME_SUCCESS, ERROR: campaignTypes.RESUME_ERROR },
        () => campaignApi.resume(id),
    )();

export const cancelCampaign = (id) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.CANCEL_PENDING, SUCCESS: campaignTypes.CANCEL_SUCCESS, ERROR: campaignTypes.CANCEL_ERROR },
        () => campaignApi.cancel(id),
    )();

export const fetchCampaignTemplates = (branchID) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.TEMPLATES_PENDING, SUCCESS: campaignTypes.TEMPLATES_SUCCESS, ERROR: campaignTypes.TEMPLATES_ERROR },
        () => campaignApi.listTemplates(branchID),
    )();

export const createCampaignTemplate = (branchID, body) => async () =>
    campaignApi.createTemplate(branchID, body);

export const fetchCampaignAnalytics = (id, window) => async (dispatch) =>
    dispatchAsync(
        dispatch,
        { PENDING: campaignTypes.ANALYTICS_PENDING, SUCCESS: campaignTypes.ANALYTICS_SUCCESS, ERROR: campaignTypes.ANALYTICS_ERROR },
        () => campaignApi.analytics(id, window),
    )();
